module.exports = __webpack_public_path__ + "static/Ranger - How to Update a Report-711b1c0d62ae6aedb4c78a66bbcdd9aa.pdf";